import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { walletConnect } from "wagmi/connectors";
import { useChain } from "../../../hooks/useChain.js";
import { useConnect } from "../../../hooks/useConnect.js";
import { useUiConfig } from "../../../hooks/useUiConfig.js";
import { WalletConnectIcon } from "../../../icons/walletConnectIcon.js";
import { Button } from "../../button.js";
import { useAuthContext } from "../context.js";
import { CardContent } from "./content.js";
import { Spinner } from "../../../icons/spinner.js";
import { ConnectionError } from "./error/connection-error.js";
import { EOAWallets } from "./error/types.js";
// eslint-disable-next-line jsdoc/require-jsdoc
export const EoaConnectCard = ({ authStep }) => {
    const { setAuthStep } = useAuthContext();
    if (authStep.error) {
        return (_jsx(ConnectionError, { connectionType: "wallet", walletType: authStep.connector.id, handleTryAgain: () => setAuthStep({
                type: "eoa_connect",
                connector: authStep.connector,
            }), handleUseAnotherMethod: () => setAuthStep({ type: "pick_eoa" }) }));
    }
    return (_jsx(CardContent, { header: `Connecting to ${authStep.connector.name}`, icon: _jsxs("div", { className: "flex relative flex-col items-center justify-center h-[58px] w-[58px]", children: [_jsx("img", { className: authStep.error ? undefined : "animate-pulse", src: authStep.connector.icon, alt: authStep.connector.name, height: 28, width: 28 }), _jsx("div", { className: "absolute top-0 left-0 w-full h-full flex items-center justify-center z-[1]", children: _jsx(Spinner, {}) })] }), description: "Please follow the instructions in your wallet to connect.", error: authStep.error }));
};
export const WalletConnectCard = ({ authStep }) => {
    const { setAuthStep } = useAuthContext();
    if (authStep.error) {
        return (_jsx(ConnectionError, { connectionType: "wallet", walletType: EOAWallets.WALLET_CONNECT, handleTryAgain: () => setAuthStep({ type: "wallet_connect" }), handleUseAnotherMethod: () => setAuthStep({ type: "pick_eoa" }) }));
    }
    // If error render the error card here?
    return (_jsx(CardContent, { header: `Connecting to WalletConnect`, icon: _jsxs("div", { className: "flex relative flex-col items-center justify-center h-[58px] w-[58px]", children: [_jsx(WalletConnectIcon, { className: "w-[32px] h-[32px]" + (authStep.error ? "" : " animate-pulse") }), _jsx("div", { className: "absolute top-0 left-0 w-full h-full flex items-center justify-center z-[1]", children: _jsx(Spinner, {}) })] }), description: "Please follow the instructions in the popup to connect.", error: authStep.error }));
};
export const EoaPickCard = () => {
    const { chain } = useChain();
    const { connectors, connect } = useConnect({
        onMutate: ({ connector }) => {
            if (typeof connector === "function") {
                setAuthStep({ type: "wallet_connect" });
            }
            else {
                setAuthStep({ type: "eoa_connect", connector });
            }
        },
        onError: (error, { connector }) => {
            if (typeof connector === "function") {
                setAuthStep({ type: "wallet_connect", error });
            }
            else {
                setAuthStep({ type: "eoa_connect", connector, error });
            }
        },
        onSuccess: () => {
            setAuthStep({ type: "complete" });
        },
    });
    const { setAuthStep } = useAuthContext();
    const { auth: { sections }, } = useUiConfig();
    const walletConnectConfig = useMemo(() => {
        const externalWalletSection = sections
            .find((x) => x.some((y) => y.type === "external_wallets"))
            ?.find((x) => x.type === "external_wallets");
        return externalWalletSection?.walletConnect;
    }, [sections]);
    const connectorButtons = connectors.map((connector) => {
        return (_jsx(Button, { className: "justify-start", variant: "social", icon: connector.icon && (_jsx("img", { src: connector.icon, alt: connector.name, height: 20, width: 20 })), onClick: () => {
                connect({ connector, chainId: chain.id });
            }, children: connector.name }, connector.id));
    });
    const walletConnectConnector = walletConnectConfig
        ? walletConnect(walletConnectConfig)
        : null;
    return (_jsx(CardContent, { className: "w-full", header: "Select your wallet", description: walletConnectConfig != null || connectors.length ? (_jsxs("div", { className: "flex flex-col gap-3 w-full", children: [connectorButtons, walletConnectConnector && (_jsx(Button, { className: "justify-start", variant: "social", icon: _jsx(WalletConnectIcon, { className: "w-[25px] h-[25px]" }), onClick: () => {
                        connect({
                            connector: walletConnectConnector,
                            chainId: chain.id,
                        });
                    }, children: "WalletConnect" }))] })) : ("No wallets available") }));
};
//# sourceMappingURL=eoa.js.map